module.exports = __webpack_public_path__ + "static/img/Subtract.e5c4b5ec.svg";